import styled from "styled-components";

export const CMCardChartSocialImpact = styled.div(props => ({

    display: 'flex',
    flexDirection: 'column',
    border: 'solid rgba(0,0,0,0.05)',
    borderRadius: '10px',
    padding: '5px',
    gap: '10px',
    maxWidth: '165px',
    maxHeight: '230px',

    '& .top-container': {
        display: 'flex',
        placeItems: 'center',
        flexDirection: 'column',
        padding: '10px',
        gap: '10px',
        width: '85%'
    },

    '& .title_container': {
        display: 'flex',
        placeItems: 'center',
        justifyContent: 'left',
        marginBottom: '5px',
        width: '100%'
    },

    '& .title_icon': {
        width: '300px'
    },

    '& .title_text': {
        fontSize: '1rem',
        fontWeight: '700'
    }, 

    '& .quantity': {
        fontSize: '2rem',
        fontWeight: '800',
        paddingLeft: '10px',
        width: '100%'
    },

    '& .diffrence_container': {
        width: '100%'
    },

    '& .difference_text':{
        fontWeight: '800',
        fontSize: '0.8rem',
        paddingLeft: '5px',
        paddingRight: '5px',
        borderRadius: '30px',
        width: 'auto',
        left: '0'
    },

    '& .text_green': {
        color: '#5cad90',
        backgroundColor: '#eaf9ec'
    },

    '& .text_red': {
        color: '#da0300',
        backgroundColor: '#f6dcdc'
    },

    '& .text_gray': {
        color: '#717375',
        backgroundColor: '#e2e2e2'
    },

    '& .chart_title': {
        color: 'gray',
        paddingLeft: '5px',
        width: '100%'
    },

    '& .chart_container': {
        width: '100%',
        display: 'flex',
        alignItems : 'center',
        backgrond: 'red'
    }

}));